(function () {
  function applyFrame(frame) {
    function size() {
      const w = frame.getBoundingClientRect().width;
      if (w) frame.style.height = w + 'px';
    }
    size();
    window.addEventListener('resize', size);
  }

  function init() {
    document.querySelectorAll('.product-image-frame').forEach(applyFrame);
    document.addEventListener('carousel:settle', function () {
      document.querySelectorAll('.product-image-frame').forEach(applyFrame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Patch openZoom: theme.js uses '> img' (direct child) but our .product-image-frame
  // wrapper sits between .product-gallery__media and img, breaking the selector.
  customElements.whenDefined('product-gallery').then(function () {
    var ProductGallery = customElements.get('product-gallery');
    ProductGallery.prototype.openZoom = function (index) {
      if (index === undefined) index = 0;
      var dataSource = Array.from(
        this.querySelectorAll('.product-gallery__media[data-media-type="image"]:not([hidden]) img')
      ).map(function (image) {
        return {
          thumbnailElement: image,
          src: image.src,
          srcset: image.srcset,
          msrc: image.currentSrc || image.src,
          width: parseInt(image.getAttribute('width')),
          height: parseInt(image.getAttribute('height')),
          alt: image.alt,
          thumbCropped: true
        };
      });
      this.photoswipe.loadAndOpen(index, dataSource);
    };
  });
})();